import React, { useState } from "react";
import "./Question.css";

function Question({ questionText, options, correctAnswer, onAnswer }) {
  const [selected, setSelected] = useState("");

  const handleChange = (e) => {
    const value = e.target.value;
    setSelected(value);
    onAnswer(value); // notify parent
  };

  return (
    <div className="question content">
      <p className="question-text">{questionText}</p>
      <ul className="options-list">
        {options.map((option) => {
          let labelClass = "option-label";

          if (selected === option.value) {
            // Only color the option that was selected
            labelClass +=
              selected === correctAnswer ? " correct" : " wrong";
          }

          return (
            <li key={option.value} className="option-item">
              <label className={labelClass}>
                <input
                  type="radio"
                  name={questionText}
                  value={option.value}
                  checked={selected === option.value}
                  onChange={handleChange}
                />
                {option.label}
              </label>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default Question;
